import { Button, FormControl, VStack } from "@chakra-ui/react";
import { Form, Formik, FormikConfig } from "formik";
import { FC } from "react";

import { FormikTextField } from "~/src/components/common/forms/FormikTextField";
import { chakraFactory } from "~/src/lib/chakra-ui";

import { CommonCard } from "../CommonCard";

import { FormValues, validationSchema } from "./validationSchema";

export type Props = {
  onSubmit: FormikConfig<FormValues>["onSubmit"];
};

const StyledLoginButton = chakraFactory(Button, {
  baseStyle: {
    width: "201px",
    height: "48px",
    backgroundColor: "#F0D209",
    marginTop: "16px",

    _focus: {
      boxShadow: "none",
    },
  },
});

const initialValues = {
  email: "",
  password: "",
};

export const SignupForm: FC<
  React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({ onSubmit }) => {
  return (
    <CommonCard>
      <Formik<FormValues>
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnMount={false}
        validateOnChange={false}
        onSubmit={onSubmit}
      >
        <Form>
          <VStack spacing="16px" alignItems="flex-start">
            <FormControl isRequired label="メールアドレス">
              <FormikTextField
                type="text"
                mode="fill"
                name="email"
                placeholder="メールアドレス"
              />
            </FormControl>
            <FormControl isRequired label="パスワード">
              <FormikTextField
                type="password"
                mode="fill"
                name="password"
                placeholder="パスワード"
              />
            </FormControl>
          </VStack>
          <StyledLoginButton type="submit">アカウントを作成</StyledLoginButton>
        </Form>
      </Formik>
    </CommonCard>
  );
};
